<template>
  <div class="user" style="background-image: url('/img/callback.jpg')">
    <b-container class="py-5">
      <div class="user-card">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            label="姓名"
            label-for="userName"
            invalid-feedback="請填寫姓名"
            :state="state.name"
            class="required"
          >
            <b-form-input
              id="userName"
              class="rounded-0"
              v-model="form.name"
              type="text"
              required
              placeholder="姓名"
              :state="state.name"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="電話"
            label-for="telephone"
            invalid-feedback="請填寫電話"
            :state="state.telephone"
            class="required"
          >
            <b-form-input
              id="telephone"
              class="rounded-0"
              v-model="form.telephone"
              type="number"
              required
              placeholder="電話"
              :state="state.telephone"
              readonly
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="公司名稱"
            label-for="userCompanyName"
            invalid-feedback="請填寫公司名稱"
            :state="state.company_name"
            class="required"
          >
            <b-form-input
              id="userCompanyName"
              class="rounded-0"
              v-model="form.company_name"
              type="text"
              required
              placeholder="公司名稱"
              :state="state.company_name"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="統一編號"
            label-for="tax_id"
          >
            <b-form-input
              id="tax_id"
              class="rounded-0"
              v-model="form.tax_id"
              type="text"
              placeholder="統一編號"
              readonly
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="公司負責人"
            label-for="principal"
            invalid-feedback="請填寫公司負責人"
            :state="state.principal"
            class="required"
          >
            <b-form-input
              id="principal"
              class="rounded-0"
              v-model="form.principal"
              type="text"
              required
              placeholder="公司負責人"
              :state="state.principal"
            ></b-form-input>
          </b-form-group>
          <TWCityTown
            @childMethod="getTWCityTown"
            :state="state.TW_city_town"
            :group_class="'required'"
            :town_id="form.town_id"
            :address="form.address"
          ></TWCityTown>
          <div class="text-right">
            <b-button squared variant="platform_main" type="submit"
              >儲存</b-button
            >
          </div>
        </form>
      </div>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
.user {
  min-height: calc((var(--vh, 1vh) * 100) - 104px - 64px - 35px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &-card {
    max-width: 450px;
    background-color: rgba(#fff, 0.9);
    padding: 30px;
    margin: 0 auto;
  }
}
</style>
<script>
import { User } from "@/assets/api/platform.js";
import TWCityTown from "@/components/TWCityTown.vue";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "User",
  props: ["token"],
  components: { TWCityTown },
  data() {
    return {
      form: {
        name: "",
        telephone: "",
        tax_id: "",
        company_name: "",
        city_id: "",
        town_id: "",
        address: "",
        principal: ""
      },
      state: {
        name: null,
        telephone: null,
        company_name: null,
        TW_city_town: null,
        principal: null
      }
    };
  },
  created() {
    User.get(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.form.name = res.data.name;
          this.form.telephone = res.data.telephone;
          this.form.tax_id = res.data.tax_id;
          this.form.company_name = res.data.company_name;
          this.form.city_id = res.data.city_id;
          this.form.town_id = res.data.town_id;
          this.form.address = res.data.address;
          this.form.principal = res.data.principal;
        } else {
          Toast.fire({
            icon: "error",
            title: "個人資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    getTWCityTown(data) {
      this.form.city_id = data.city_id;
      this.form.town_id = data.town_id;
      this.form.address = data.address;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.form.name ? (this.state.name = null) : (this.state.name = false);
      this.form.company_name
        ? (this.state.company_name = null)
        : (this.state.company_name = false);
      this.form.town_id && this.form.address && this.form.city_id
        ? (this.state.TW_city_town = null)
        : (this.state.TW_city_town = false);
      this.form.principal
        ? (this.state.principal = null)
        : (this.state.principal = false);
      this.form.telephone
        ? (this.state.telephone = null)
        : (this.state.telephone = false);
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const [key, value] of Object.entries(this.state)) {
        if (value === false) {
          console.log(key);
          return;
        }
      }
      User.update(this.form, this.token)
        .then(res => {
          if (res.status <= 201) {
            Toast.fire({
              icon: "success",
              title: "修改成功"
            });
          } else {
            Toast.fire({
              icon: "error",
              title: "修改失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
